<template>
	<div>
		<div class="coupons-box">

			<div class="coupons-title">
				<span class="title" style="color:#666">优惠券({{data.length}})</span>
				<span class="fr" style="color:#00af66" @click="useCoupons">关闭</span>
			</div>

			<div class="coupons-list">
				<div class="coupons-item" v-for="item in data" :key='item.id'
					:class="{ 'disabled': item.state === 'NOT_FEASIBLE' || item.state === 'IGNORE' || item.state==='NOT_AVAILABLE' }">
					<div class="title">{{item['coupon_name']}}</div>
					<div class="tiem">有效期至:{{item['end_time']}}</div>
					<div class="btn" v-if="item.state==='AVAILABLE' || item.state==='FEASIBLE'" @click="useCoupons(item)">使用</div>

					<div class="btn cancel" v-if="item.state==='CHOSEN'" @click="removeCoupon(item)">取消</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
	export default {

		props: [
			'data',
			'active'
		],
		data() {
			return {
				localActive: []
			}
		},
		watch: {
			active: {
				immediate: true,
				handler(val) {
					this.localActive = (val || []).slice();
				}
			}
		},
		methods: {

			useCoupons(item) {

				//console.log(item.coupon_code);
				var filtered = this.localActive.filter(function(i) { return i !== null; });
				filtered.push(item.coupon_code);
				this.localActive = filtered;

				this.$emit("couponCb", this.localActive);
			},
			removeCoupon(item) {

				var list = this.localActive.slice();
				var index = list.indexOf(item.coupon_code);

				if (index !== -1) {
					list.splice(index, 1);
					this.localActive = list;
					this.$emit('couponCb', this.localActive);
				}

			},
		}
	};
</script>

<style lang="scss" scoped>
	.disabled {
		opacity: 0.4;
		cursor: not-allowed;
	}

	.disabled:hover {
		opacity: 0.4;
		cursor: not-allowed;
	}

	.disabled:active {
		opacity: 0.4;
		cursor: not-allowed;
	}

	.disabled:focus {
		opacity: 0.4;
		cursor: not-allowed;
		outline: none;
	}

	.coupons-box {
		display: flex;
		flex-direction: column;
		height: 100%;

		.coupons-title {
			height: 88px;
			padding: 0 40px;
			line-height: 88px;
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

			.title {
				color: #666;
				font-weight: bold;
				font-size: 28px;
			}
		}

		.coupons-list {
			flex: 1;
			min-width: 0;
			overflow: auto;
		}
	}

	.coupons-item {
		margin: 30px;
		padding: 30px 20px;
		border-radius: 16px;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
		position: relative;

		.btn {
			position: absolute;
			right: 40px;
			top: 50%;
			margin-top: -30px;
			width: 150px;
			height: 60px;
			line-height: 60px;
			text-align: center;
			background: #00af66;
			color: #fff;
			border-radius: 30px;
			letter-spacing: 2px;

			&.cancel {
				background: #ffff;
				border: 1px solid #333;
				color: #333;
			}
		}

		.title {
			font-size: 30px;
			font-weight: bold;
			margin-bottom: 20px;
		}

		.tiem {
			color: #666;
			font-size: 24px;
		}
	}
</style>